import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import AmazonSection from '../components/AmazonSection';
import PricingSection from '../components/PricingSection';
//import HowItWorksSection from '../components/HowItWorksSection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import TestimonialsSection from '../components/TestimonialsSection';
import CTASection from '../components/CTASection';
import InquiryModal from '../components/InquiryModal';

const Home = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContext, setModalContext] = useState('');
  const [tmSignUpType, setTmSignUpType] = useState(1);
  const [packageInfo, setPackageInfo] = useState({ title: 'Basic', amount: 45 });

  const handleOpenModal = (context, tmType = null, pkgInfo = null) => {
    setModalContext(context);
    if (tmType !== null) {
      setTmSignUpType(tmType);
    }
    if (pkgInfo !== null) {
      setPackageInfo(pkgInfo);
    }
    setIsModalOpen(true);
  };

  const handleTmSignUpTypeChange = (tmType) => {
    setTmSignUpType(tmType);
  };

  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Trademark Essential - Professional Trademark Registration & IP Protection</title>
        <meta name="description" content="Expert trademark registration services. Protect your brand with affordable, comprehensive IP solutions. Get started today with our trusted attorneys." />
      </Helmet>
      <HeroSection onOpenModal={handleOpenModal} />
      <AboutSection />
      <ServicesSection />
      <AmazonSection onOpenModal={handleOpenModal} />
      {/* <HowItWorksSection onOpenModal={handleOpenModal} /> */}
      <PricingSection onOpenModal={handleOpenModal} onTmSignUpTypeChange={handleTmSignUpTypeChange} />
      <WhyChooseUsSection />
      <TestimonialsSection />
      <CTASection onOpenModal={handleOpenModal} />
      <InquiryModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        buttonContext={modalContext}
        tmSignUpType={tmSignUpType}
        packageInfo={packageInfo}
      />
    </div>
  );
};

export default Home;